export default {"src":"/_next/static/media/top-seller.acc912b2.svg","height":28,"width":22};